import type { AxiosResponse } from 'axios';
import { appAxios } from 'utils/appAxios';

export type SignInRequest = Required<{
  email: string;
  password: string;
  rememberMe: boolean;
  individual?: boolean;
}>;

export const postSignIn = async (
  data: SignInRequest
): Promise<AxiosResponse> => {
  return await appAxios.post('/sign_in', data);
};
